// Normaliza los valores de catálogo del PAE Detallado guardados con la
// puntuación vieja.
//
// Hasta el recorrido de claridad del 2026-09-03 las opciones de los Select y
// RadioGroup del PAE Detallado eran VALOR y etiqueta a la vez, escritas con
// guión largo ("Ausentes — íleo", "Funcional — permeable"), y el fundador
// prohibió los guiones largos en todo texto visible (norma 2026-07-16). El
// catálogo pasó a dos puntos ("Ausentes: íleo") con una transformación única,
// así que un valor viejo se reconoce sin tabla: basta reemplazar " — " por
// ": ". Regla de la casa: el valor viejo se normaliza al LEER, jamás se migra.
//
// Entra en los dos puntos por donde un formData guardado vuelve a la app (el
// borrador de localStorage y un PAE guardado en `paes.datos`) para que
// `henderson.js`, que compara por igualdad literal, siga reconociendo lo que
// la persona eligió antes del cambio.
const GUION_VIEJO = / — /g;

export function normalizarTextoPae(valor) {
  return typeof valor === 'string' ? valor.replace(GUION_VIEJO, ': ') : valor;
}

export function normalizarValoresPae(formData) {
  if (Array.isArray(formData)) return formData.map(normalizarValoresPae);
  if (!formData || typeof formData !== 'object') return normalizarTextoPae(formData);
  const salida = {};
  for (const [k, v] of Object.entries(formData)) salida[k] = normalizarValoresPae(v);
  return salida;
}
